import { UpdatePaymentStatusPayload } from "@ac-expo/api-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { paymentHistoryQueryKeys } from "../query-keys/payment-history.query-keys";

const updatePaymentStatus = async ({
  orderId,
  status,
}: UpdatePaymentStatusPayload) => {
  const { data } = await privateAxios.patch(
    `/payment-history/${orderId}/status`,
    { status }
  );
  return data;
};

export const useUpdatePaymentStatusMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updatePaymentStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: paymentHistoryQueryKeys.all });
    },
  });
};
